import _ui from "./uiReducer";
import _users from "./userReducer";
import _posts from "./postReducer";
import _attendees from "./attendeesReducer";

// UI REDUCER
export const ui = _ui;

// USERS REDUCER
export const users = _users;

//POSTS REDUCER
export const posts = _posts;

// ATTENDEES REDUCER
export const attendees = _attendees;
